import { removeLocalStorageKey } from "./local-storage-backed-load";
import { getImpersonatingEmployee } from "../app/impersonate-service";

const classCachePrefix = "classes";
const sisClassCachePrefix = "sisClasses";

const sanitizeStorageKeySegment = (value) => {
  const valueAsString = `${value ?? ""}`;
  if (!valueAsString) {
    return "self";
  }

  return valueAsString.replace(/[^a-zA-Z0-9_-]/g, "_");
};

const getUserCacheIdentity = () => {
  const impersonating = getImpersonatingEmployee();
  return sanitizeStorageKeySegment(impersonating?.churchAccountId ?? "self");
};

const buildUserScopedCacheKey = (baseKey) => {
  return `${baseKey}_${getUserCacheIdentity()}`;
};

const buildClassesCacheKey = (termId, isSucceedInSchool = false) => {
  const prefix = isSucceedInSchool ? sisClassCachePrefix : classCachePrefix;
  return buildUserScopedCacheKey(`${prefix}_${termId}`);
};

const removeLocalStorageClasses = (termId) => {
  if (!termId) {
    return;
  }

  const termAsString = `${termId}`;
  // remove legacy cache keys
  removeLocalStorageKey(`${classCachePrefix}_${termAsString}`, true);
  removeLocalStorageKey(`${sisClassCachePrefix}_${termAsString}`, true);

  // remove impersonation-scoped cache keys
  try {
    const sessionStorage = window.sessionStorage;
    const classPrefix = `${classCachePrefix}_${termAsString}_`;
    const sisClassPrefix = `${sisClassCachePrefix}_${termAsString}_`;
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (!key) {
        continue;
      }
      if (key.startsWith(classPrefix) || key.startsWith(sisClassPrefix)) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    // no-op
  }
};

export default removeLocalStorageClasses;
export { buildClassesCacheKey, buildUserScopedCacheKey };
